import NextButton from '@/components/forms/ButtonNext.vue';
// import getAQuote from "@/mixins/get-a-quote.js"

export default {
    $_veeValidate: {
        validator: 'new'
    },
    name: "NewBusinessEducatorInformation",
    props: {
        title: String,
        instruction: String
    },
    components: {
        NextButton
    },
    data() {
        return {
            config: {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                params: {
                    "token": this.$store.state.NewBusinessToken,
                    "token_name": this.$store.state.NewBusinessTokenName
                }
            },
            // baseURL: window.location.origin, //window.location.origin, #NOT NEEDED CHECK MAINJS FOR GLOBAL READONLY DATA
            first_name: '',
            last_name:'',
            trading_name:  '',
            business_name: '',
            insured_name: '',
            email: '',
            init_date_birth: moment(new Date(), 'YYYY-MM-DD').subtract(18,'years').format('YYYY-MM-DD'),
            date_of_birth: moment(new Date(), 'YYYY-MM-DD').subtract(18,'years').format('YYYY-MM-DD'),
            use_full_name_as_business_name: true,
            mobile_phone_number: '',
            home_phone_number:'',
            menu: false,
            menu2: false,
            dictionary: {
                attributes: {
                    first_name: 'First Name',
                    last_name: 'Last Name',
                    trading_name: 'Trading Name',
                    email: 'Email Address',
                    mobile_phone_number: 'Mobile Number',
                    home_phone_number: 'Landline Number'
                }
            }, 
            user_id: '',
            session_id: '',

            educatorInformationSubmitted: false,
        }

    },
    computed: {
        computedDateFormattedDateOfBirth() {
            return this.date_of_birth ? moment(this.date_of_birth).format('DD/MM/YYYY') : ''
        }
    },
    watch: {
        isFullNameSimilar: function(val) {

            this.$store.commit('mutate', {
                property: "NewBusinessFullNameSimilar",
                value: val
            });

            if (!val) {
                this.trading_name = '';
                this.business_name = '';
            } else {
                this.trading_name = this.first_name + ' ' + this.last_name;
                this.business_name = this.first_name + ' ' + this.last_name;
            }

            return val;

        },

        first_name: function(val) {
            this.trading_name = this.first_name + ' ' + this.last_name;
            this.business_name = this.first_name + ' ' + this.last_name;
            this.insured_name = this.first_name + ' ' + this.last_name;
        },
        last_name: function(val) {
            this.trading_name = this.first_name + ' ' + this.last_name;
            this.business_name = this.first_name + ' ' + this.last_name;
            this.insured_name = this.first_name + ' ' + this.last_name;
        },
        email: function(val) { /* forced email to transform to lower case | https://pm.cbo.me/#/tasks/17496071 */
            if(val) {
                this.email = val.toLowerCase();
            }
        }
    },
    methods: {
        setTextFormat(value, format) {
            return value = format == 'uppercase' ? value.toUpperCase() : value.toLowerCase();
        },
        async getCustomerDetails() {
            
            let payload = {
                method: 'get',
                url: `${this.baseURL}/api/cfa/get_cfa_customer_by_email.json`,
                params: {
                    email: this.email
                }
            },
            response = await this.$store.dispatch('fetchData', payload);
            if(response.data.items) {
                if(response.data.items.results.length > 0) {
                    this.setCustomerDetails(response);
                } else {
                    this.setAllowedToCreateNewBusiness(true);
                }
            }

        },
        setCustomerDetails($response) {
            this.$store.commit('mutate', {
                property: 'customerDetails',
                value: $response.data.items.results[0]
            })
            this.checkIfCustomerHasAdminProfile();
        },
        async checkIfCustomerHasAdminProfile() {
            let adminProfile = this.$store.state.customerDetails.profiles.filter(data => {
                return data.profile_type === "modules/fdca-cfa/cfa_admin";
            });
            
            if(adminProfile.length === 0 || this.isInvalid(adminProfile[0].properties.password_token)) {
                this.setAllowedToCreateNewBusiness(true);
            } else {
                this.educatorInformationSubmitted = false;
                this.setAllowedToCreateNewBusiness(false);
            }
            
        },
        proceedWithSubmitForm() {

            let customerPayload = {
                email: this.email
            }

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.user_type",
                value: 'educator'
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.first_name",
                value: this.first_name
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.last_name",
                value: this.last_name
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.business_name",
                value: this.trading_name
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.insured_name",
                value: this.insured_name
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.email",
                value: this.email
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.date_of_birth",
                value: this.date_of_birth
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.use_full_name_as_business_name",
                value: this.use_full_name_as_business_name
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.mobile_phone_number",
                value: this.mobile_phone_number
            });

            this.$store.commit('mutate', {
                property: "sessionDetails.properties.home_phone_number",
                value: this.home_phone_number
            });
            
            this.$emit("createUpdateSession");
        },
        setAllowedToCreateNewBusiness($value) {
            // allowed to create new business if
            // valid email
            // does NOT have cfa admin profile
            this.$store.commit('mutate', {
                property: 'isAllowedToCreateNewBusiness',
                value: $value
            })
            if($value === false) {
                Swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: 'This email is not allowed to create a new business. Please contact customer service for assistance.'
                })
            } else if($value === true) {
                this.proceedWithSubmitForm();
            }
        },
        checkStoreData() {
            this.first_name = this.$store.state.sessionDetails.properties.first_name;
            this.last_name = this.$store.state.sessionDetails.properties.last_name;
            this.trading_name = this.$store.state.sessionDetails.properties.business_name;
            this.insured_name = this.$store.state.sessionDetails.properties.insured_name;
            this.email = this.$store.state.sessionDetails.properties.email;
            this.date_of_birth = this.$store.state.sessionDetails.properties.date_of_birth;
            this.use_full_name_as_business_name = this.$store.state.sessionDetails.properties.use_full_name_as_business_name;
            this.mobile_phone_number = this.$store.state.sessionDetails.properties.mobile_phone_number;
            this.home_phone_number = this.$store.state.sessionDetails.properties.home_phone_number;
        },
        initApp() {
            this.checkStoreData();
        },
        backToPrevious() {
            this.$store.commit('mutate', {
                property: "NewBusinessStep",
                value: this.$store.state.NewBusinessStep + 1
            });
        },
        commitStateValues(property, value) {
            this.$store.commit('mutate', {
                property: property,
                value: value
            });
        },
        async checkIfEmailExistsInCrm(payload) {

            let responseData = '';

            await this.$store.dispatch('fetchData', payload)
            .then(function(response) {
                if(response.status == 200) {
                    responseData = response.data;
                } else {
                    Swal.fire({
                        type: 'error',
                        title: 'Error',
                        text: 'A problem was encountered with the request. (inner)'
                    })
                }
            }).catch(function(error) {
                Swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: 'A problem was encountered with the request. (outer)'
                })
            });

            return responseData;

        },

        getCurrentSessionID() {
            this.session_id = this.$store.state.sessionDetails.session_id;
            return this.session_id;
        },

        validateFormMode() {
            const currentSessionID = this.getCurrentSessionID();
            return !!currentSessionID
                ?   'UPDATE'
                :   'ADD'  
        },

        async submitForm() {
            this.educatorInformationSubmitted = true;

            let is_valid = await this.$validator.validateAll();
            let sessionDetailsPayload = this.$store.state.sessionDetails.properties;

            if(is_valid) {

                this.getCustomerDetails();

            } else {

                this.educatorInformationSubmitted = false;

            }

        },

        createPayloadStructureAndStringify(currentSessionID, fields) {
            let payload = {
                id: currentSessionID,
                properties: {}
            }

            this.draft.first_name = this.first_name;
            this.draft.last_name = this.last_name;
            this.draft.trading_name = this.trading_name;
            this.draft.business_name = this.business_name;
            this.draft.email = this.email;
            this.draft.date_of_birth = this.date_of_birth;
            this.draft.use_full_name_as_business_name = this.use_full_name_as_business_name;
            this.draft.mobile_phone_number = this.mobile_phone_number;
            this.draft.home_phone_number = this.home_phone_number;
            this.draft.session_id = this.session_id;

            const values = Object.values(fields);
            const keys = Object.keys(fields);

            

            keys.forEach((item, i) => {
                if(typeof values[i] === "boolean"){
                    payload.properties[keys[i]] = values[i] ? "true": "false"
                  }
                  else if(typeof values[i] === "Number"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "addresses"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "insured_address"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "relief_educators"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "additional_cover"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "activities"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "dual_educators"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "registered_service"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "additional_branches"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else if(keys[i] === "interested_parties"){
                    payload.properties[keys[i]] = JSON.stringify(values[i])
                  }
                  else {
                    payload.properties[keys[i]] = values[i]
                  }
            
            });

            return payload;

        },

        async addSession(payload, callback) {

            let requestPayload = {
                method: 'post',
                url: `${this.baseURL}/main/add_session.json`,
                params: {
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                },
                data: payload.properties
            }

            let response = await this.$store.dispatch('fetchData', requestPayload);
        },

        async updateSessionByID(payload, callback) {

            let requestPayload = {
                method: 'put',
                url: `${this.baseURL}/main/update_sessions.json`,
                params: {
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                },
                data: payload.properties
            }

            let response = await this.$store.dispatch('fetchData', requestPayload);
        },
        setInitialSessionValues() {
            this.$store.commit('mutate', {
                property: "sessionDetails.properties.addresses",
                value: []
            });
    
            this.$store.commit('mutate', {
                property: "sessionDetails.properties.payment_terms",
                value: "annual"
            });
            httpRequest.post("url", payload)
                .then(data => callback(true, data))
                .catch(error => callback(false, error))
        }

    },
    mounted() {
        this.initApp();
        this.$validator.localize('en', this.dictionary);

        if (localStorage.getItem("session_id") && sessionStorage.getItem("done_on_prompt") != "yes") {
            sessionStorage.setItem("done_on_prompt", "yes");
            Swal.fire({
                title: '',
                text: "You have existing session, Do you want to continue?",
                icon: 'info',
                showCancelButton: true,
                cancelButtonText: 'No',
                confirmButtonColor: '#1cb053',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
              }).then((result) => {
                if (result.value) {
                    
                } else if (
                    /* Read more about handling dismissals below */
                    result.dismiss === Swal.DismissReason.cancel
                  ) {
                    localStorage.removeItem("session_id");
                    this.first_name = '';
                    this.last_name= '';
                    this.trading_name=   '';
                    this.business_name=  '';
                    this.insured_name=  '';
                    this.email=  '';
                    this.mobile_phone_number=  '';
                    this.home_phone_number= '';
                    this.init_date_birth = "";
                    this.date_of_birth = "";
                    sessionStorage.setItem("done_on_prompt", "no");
                }
            })
        }

    }
}